import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import FormSectionProductConfiguration from './FormSectionProductConfiguration';
import formSubmit from '../../actions/formSubmit';
import { PRODUCT_FORM } from '../../constants/formNames';
import { validateProductName } from '../../utils/productNameValidation';

export const validation = (val: unknown): boolean =>
  !val || (typeof val === 'object' && (val as unknown[]).length === 0);
export const validateBool = (val: unknown): boolean =>
  !(val === true || val === false);
export const minLenAndReqAndAllNumVal = validateProductName;

const defaultInitialValues = {
  public: false,
  aroma: false,
  productFeature: [],
  productComponentBase: [],
  productComponentOther: [],
  productCategory: [],
  texture: true,
  prototype: false,
  questions: [],
};

const mapStateToProps = (_state, ownProps) => {
  const cloneData = ownProps.location?.state?.cloneData;

  return {
    initialValues: cloneData
      ? { ...defaultInitialValues, ...cloneData }
      : defaultInitialValues,
  };
};

const ConnectedForm = connect(mapStateToProps)(
  reduxForm({
    form: PRODUCT_FORM,
    onSubmit: (values, dispatch) => {
      dispatch(formSubmit(PRODUCT_FORM));
    },
    validate: (values) => {
      return {
        name: minLenAndReqAndAllNumVal(values.name),
        brand: validation(values.brand),
        prototype: validateBool(values.prototype),
        productCategory: validation(values.productCategory),
        productFeature: validation(values.productFeature),
        productComponentBase: validation(values.productComponentBase),
        allergens: validation(values.allergens),
        restrictions: validation(values.restrictions),
        physicalState: validation(values.physicalState),
        countryOfPurchase: validation(values.countryOfPurchase),
        country: validation(values.country),
      };
    },
    enableReinitialize: true,
  })(FormSectionProductConfiguration),
);

export default ConnectedForm;
